import React from 'react';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  /** `listPage` matches Projects toolbar search (elevation bar, h-11). */
  variant?: 'default' | 'listPage';
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Search...',
  value,
  onChange,
  className = '',
  variant = 'default',
}) => {
  if (variant === 'listPage') {
    return (
      <div
        className={`flex w-full md:max-w-md items-stretch rounded-xl h-11 bg-elevation-dark border border-border-dark shadow-sm overflow-hidden focus-within:border-primary/50 transition-colors ${className}`}
      >
        <div className="text-slate-500 flex items-center justify-center pl-4 shrink-0">
          <span className="material-symbols-outlined">search</span>
        </div>
        <input
          type="search"
          className="w-full min-w-0 border-none bg-transparent focus:ring-0 text-white px-3 text-sm placeholder:text-slate-500 focus:outline-none font-display"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
        search
      </span>
      <input
        className="w-full h-12 pl-12 pr-4 rounded-lg bg-dialog-bg text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary font-display"
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
